import React, { Component } from "react"
import {
  Col,
  FormControl,
  Row
} from "react-bootstrap"
import CloseableProcessesStatus from "../fragments/CloseableProcessesStatus"
import { blockingFetchService } from "../../lib/blockingFetch"
import apiServerApi from "../../redux/sagas/apiServerApi"
import AlertModal from "../fragments/AlertModal"

class UpdateAffiliation extends Component {

  state = {
    running: false,
    success: false,
    error: null,
    closeStatuses: false,

    businessId: this.props.businessId,
    dataChanged: false,
  }

  saveAffiliation = () => {

    this.setState({
      success: false,
      running: true,
      error: null,
      closeStatuses: false,
    })

    const { customerId, setCustomer } = this.props,
    { businessId } = this.state

    blockingFetchService(
      accessToken => apiServerApi.affiliateCustomer(accessToken, customerId, businessId), 
      resp => {
        setCustomer(customerId, resp)
        this.setState({ success: true })
        setTimeout(this.handleClose, 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  businessIdChanged = businessId => this.setState({ businessId, dataChanged: true })

  handleClose = () => {
    this.setState({
      success: false,
      running: false,
      error: null,
      closeStatuses: false,
      dataChanged: false,
    })
    this.props.close()
  }

  renderBody = () => {
    const { businesses } = this.props,
    { success, running, error, closeStatuses, businessId } = this.state

    return <div>
      <Row className="mb-20">
        <Col xs={4}>Choose a business</Col>
        <Col xs={8}>
          <FormControl componentClass="select" placeholder="select" disabled={ running }
            value={ businessId }
            onChange={e => this.businessIdChanged(e.target.value)}>
            <option value=""></option>
            { businesses.map(item => <option key={ item.id } value={ item.id }>
              { item.name } - { item.businessId }</option>) }
          </FormControl>
        </Col>
      </Row>

      <CloseableProcessesStatus
        error={ error }
        running={ running }
        success={ success }
        close={ closeStatuses }
        handleClose={() => this.setState({ closeStatuses: true })}
      />
    </div>
  }

  render() {
    const { show, fullName } = this.props,
    { running, dataChanged } = this.state

    return <AlertModal
      title={ <span>Update <strong>&#171; { fullName } &#187;</strong> affiliation</span> }
      show={ show }
      close={ this.handleClose }
      confirm={ this.saveAffiliation }
      body={ this.renderBody() }
      proceedText="Update"
      bsStyle="success"
      disabled={ running || !dataChanged }
    /> 
  }
}

export default UpdateAffiliation



// WEBPACK FOOTER //
// ./src/components/Customers/UpdateAffiliation.js